export const breadcrumbResolvers = {
  patient: (state) => state.patient.detailViewData,
  customer: (state) => state.customer.detailViewData,
  formulary: (state) => state.customer.customerAssignedFormulary,
  user: (state) => state.user.detailViewData,
  sso: (state) => state.user.detailSsoViewData,
  layout: (state) => state.layouts.deatilLayout,
  form: (state) => state.forms.formDetailsData,
  support: (state) => state.support.questions,
  assessment: (state) => state.patient.detailAssessment,
};
